import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

interface CardProgressLabelProps {
  current: number;
  total: number;
}

const CardProgressLabel: FC<CardProgressLabelProps> = ({ current, total }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Typography className={classes.progressLabel}>
      {t('page.pathway.progressLabel', { current, total })}
    </Typography>
  );
};

export default CardProgressLabel;
